import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

// Import helpers
import { textTruncate, maxFileName } from './helpers';

// Import styled components
import { Content } from './styles';

function FieldContent({ title, placeholder, inProgress }) {
	const text = title ?? placeholder;
	return (
		<Content $placeholder={inProgress || !title}>
			{text.length > maxFileName ? (
				<Tooltip title={text}>{textTruncate(text)}</Tooltip>
			) : (
				text
			)}
		</Content>
	);
}

FieldContent.defaultProps = {
	inProgress: false
};

FieldContent.propTypes = {
	placeholder: PropTypes.string.isRequired,
	title: PropTypes.string,
	inProgress: PropTypes.bool
};

export default FieldContent;
